import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import SidebarContainer from '../SidebarContainer';
import announcementsActions from '../../redux/announcements/actions';
import dealersActions from '../../redux/dealers/actions';
import ErrorMessage from '../../components/ErrorMessage';
import './Announcement.scss';

import {
  AnnouncementEditor,
  NewAnnouncement,
} from '../../components/AnnouncementEditor';

class Announcement extends Component {
  componentDidMount() {
    const { announcementId } = this.props.match.params;
    if (announcementId) {
      this.props.actions.announcementRequest(announcementId);
    } else {
      this.props.actions.resetAnnouncement(announcementId);
    }
    this.props.actions.dealersRequest();
  }

  onCreate = params => {
    this.props.actions.createAnnouncementRequest(params);
  };

  onSave = announcement => {
    this.props.actions.updateAnnouncementRequest(announcement);
  };

  render() {
    const { announcements, dealers, history } = this.props;
    const { announcement, error, fetching } = announcements;

    return (
      <SidebarContainer title={announcement.title}>
        {error && <ErrorMessage error={error} />}
        <div className="announcements-table">
          {announcement.id && (
            <AnnouncementEditor
              announcement={announcement}
              dealers={dealers}
              fetching={fetching}
              onSave={this.onSave}
              history={history}
            />
          )}
          {!announcement.id && (
            <NewAnnouncement
              announcement={announcement}
              dealers={dealers}
              fetching={fetching}
              history={history}
              onCreate={this.onCreate}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

Announcement.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  history: PropTypes.object,
  dealers: PropTypes.array,
  announcements: PropTypes.object,
};

const mapStateToProps = ({ announcements, dealers }) => ({
  announcements,
  dealers: dealers.dealers,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...announcementsActions, ...dealersActions },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Announcement),
);
